export const IMG = {
  hero: process.env.PUBLIC_URL + "/generated/hero.png",
  structural: process.env.PUBLIC_URL + "/generated/structural.png",
  inner: process.env.PUBLIC_URL + "/generated/inner.png",
  metabolic: process.env.PUBLIC_URL + "/generated/metabolic.png",
  founder: process.env.PUBLIC_URL + "/generated/founder.png",
  philosophy: process.env.PUBLIC_URL + "/generated/philosophy.png",
  method: process.env.PUBLIC_URL + "/generated/method.png",
  journal: process.env.PUBLIC_URL + "/generated/journal.png",
  svcFitCall: process.env.PUBLIC_URL + "/generated/svc-fit-call.png",
  svcAssessment: process.env.PUBLIC_URL + "/generated/svc-assessment.png",
  svcIntensive: process.env.PUBLIC_URL + "/generated/svc-intensive.png",
  svcIntegration: process.env.PUBLIC_URL + "/generated/svc-integration.png",
  svcConcierge: process.env.PUBLIC_URL + "/generated/svc-concierge.png",
  svcEducation: process.env.PUBLIC_URL + "/generated/svc-education.png",
};

export const SERVICE_IMAGES = [
  // Same order as translations home.services[]
  process.env.PUBLIC_URL + "/generated/svc-fit-call.png",
  process.env.PUBLIC_URL + "/generated/svc-assessment.png",
  process.env.PUBLIC_URL + "/generated/svc-intensive.png",
  process.env.PUBLIC_URL + "/generated/svc-integration.png",
  process.env.PUBLIC_URL + "/generated/svc-concierge.png",
  process.env.PUBLIC_URL + "/generated/svc-education.png",
];

export const LOGO_MONOGRAM = "https://customer-assets-4nw71qhi.emergentagent.net/job_6305a95b-4e96-4a63-9500-26f1a3d3f9df/artifacts/lq7dgvpf_F5E2043A-7DC1-4500-9E7E-70A274945FB6.PNG";
export const LOGO_WORDMARK = "https://customer-assets-4nw71qhi.emergentagent.net/job_6305a95b-4e96-4a63-9500-26f1a3d3f9df/artifacts/8vpht3jz_59E7649E-8086-474B-9DAE-4B487833A87A.PNG";
